import { request } from "../axios/request";

export const getAssetGroupsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-groups", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAssetGroupWithCustomFields = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-groups/customFields/" + id, getState(), {
        method: "GET",
      })
    );
  };
};

export const getAllAssetGroupsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-groups", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveAssetGroupService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/asset-groups/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-groups", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteAssetGroupService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-groups/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
